import { api } from '@/services'
import { updateProfile } from '@/services/user/userService'
import Vue from 'vue'

const state = {
  user: {},
  updateProfileDialog: false,
}

const getters = {
  user: (state) => state.user,
  updateProfileDialog: (state) => state.updateProfileDialog,
}

const actions = {
  async fetchUser({ commit, dispatch }) {
    try {
      const { data } = await api.get('/web/user/current')
      commit('setUser', data)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },
  async updateUserProfile({ commit, dispatch }, requestBody) {
    commit('setIsLoading', true)
    try {
      const { data } = await updateProfile(requestBody)
      dispatch('showSuccessMessage', 'Perfil atualizado com sucesso!')
      dispatch('fetchUser')
      commit('setUpdateProfileDialogStatus', false)
    } catch ({ data }) {
      if (data.errors) {
        let errorMessage = ''
        data.errors.forEach((error) => {
          errorMessage +=
            Vue.i18n.translate('host.label.' + error.field) +
            ': ' +
            error.message +
            ' '
        })
        dispatch('showErrorMessage', errorMessage)
      } else {
        dispatch('showErrorMessage', data.message)
      }
    } finally {
      commit('setIsLoading', false)
    }
  },
}

const mutations = {
  setUser: (state, status) => {
    state.user = status
  },
  setUpdateProfileDialogStatus: (state, status) => {
    state.updateProfileDialog = status
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
